"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var pathOr_1 = __importDefault(require("ramda/src/pathOr"));
var uuid_1 = require("uuid");
var mySavillsTrackingActions_1 = require("./mySavillsTrackingActions");
var utils_1 = require("./utils");
var logger_1 = require("./logger");
navigator.serviceWorker.register('/serviceWorker.js?v=0.0.1')
    .then(function (registration) {
    logger_1.logger.info('ServiceWorker registration successful with scope: ', registration.scope);
}).catch(function (err) {
    logger_1.logger.error('ServiceWorker registration failed: ', err);
});
function send(_a) {
    var action = _a.action, state = _a.state, headers = _a.headers;
    if (!mySavillsTrackingActions_1.APPROVED_TYPES.includes(action.type))
        return;
    navigator.serviceWorker.ready.then(function (registration) {
        var _a;
        (_a = registration.active) === null || _a === void 0 ? void 0 : _a.postMessage({
            type: 'tracking',
            payload: __assign(__assign({}, (0, utils_1.formatAction)(state, action)), { pingId: (0, uuid_1.v4)(), sessionId: (0, utils_1.getSessionId)(), gpsId: headers.GpsProfileId, gpsLanguageCode: headers.GpsLanguageCode, gpsCountryCode: headers.GpsCountryCode, path: (0, pathOr_1.default)("".concat(window.location.pathname).concat(window.location.search), ['routerMap', 'currentRoute', 'as'], state) }),
        });
    }).catch(function (error) {
        logger_1.logger.error(error);
    });
}
Object.defineProperty(window, 'msTrackingApi', { value: { send: send }, writable: false });
